// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import releaseApprovalEntity from './entities/release-approval.json';
import releaseApprovalMenu from '../pages/release-approval/menu.json';
import releaseApprovalFullForm from '../pages/release-approval/forms/full.json';
import releaseApprovalContextForm from '../pages/release-approval/forms/context.json';
import releaseApprovalMiniForm from '../pages/release-approval/forms/mini.json';
import releaseApprovalLookupForm from '../pages/release-approval/forms/lookup.json';
import releaseApprovalTableView from '../pages/release-approval/views/table.json';
import releaseApprovalCardsView from '../pages/release-approval/views/cards.json';
import releaseApprovalCalendarView from '../pages/release-approval/views/calendar.json';
import releaseApprovalDashboardView from '../pages/release-approval/views/dashboard.json';

/** Тип запису «Погодження релізу» зі сторінками пакета: меню, форми та подання з pages/release-approval/. */
export const releaseApprovalDefinition: IRecordTypeDefinition = {
  ...releaseApprovalEntity,
  views: assembleViewSet({
      table: releaseApprovalTableView,
      cards: releaseApprovalCardsView,
      calendar: releaseApprovalCalendarView,
      dashboard: releaseApprovalDashboardView,
  }),
  form: releaseApprovalFullForm,
  forms: { full: releaseApprovalFullForm, context: releaseApprovalContextForm, mini: releaseApprovalMiniForm, lookup: releaseApprovalLookupForm },
  menu: releaseApprovalMenu,
} as IRecordTypeDefinition;
